<gsp-popup
    [heading]="'MapViewer.Workspace.CropImage.Header' | translate"
    [size]="ModalSize.FluidLarge"
    id="image-cropper-popup"
    [showDone]="true"
    (done)="selectCroppedImage()"
    [doneBtnTitle]="'MapViewer.Workspace.CropImage.Button' | translate"
    [showClose]="true"
    (closed)="closeCropper()"
    [showCancel]="true"
    (cancel)="closeCropper()"
>
    <ng-container transclude-popup-content>
        <custom-scroll>
            <input
                #fileInput
                [hidden]="true"
                id="image-cropper-input"
                type="file"
                accept="image/*"
                (change)="fileChangeEvent($event)"
            />

            <p>
                {{
                    noErrorsFound
                        ? ('MapViewer.Workspace.CropImage.Message' | translate)
                        : ('MapViewer.Workspace.CropImage.ErrorMessage' | translate)
                }}
            </p>

            <div>
                <button
                    type="button"
                    id="reselectFileButton"
                    class="button-main button button-tooltip button-primary button-icon-text"
                    (click)="fileInput.click()"
                    [hidden]="noErrorsFound"
                >
                    {{ 'MapViewer.Workspace.CropImage.SelectImageFile' | translate }}
                </button>
            </div>

            <div class="crop-wrapper" [hidden]="!noErrorsFound">
                <image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [containWithinAspectRatio]="true"
                    [imageQuality]="100"
                    [aspectRatio]="aspectRatio"
                    [resizeToWidth]="resizeToWidth"
                    [resizeToHeight]="resizeToHeight"
                    format="jpeg"
                    (imageCropped)="imageCropped($event)"
                    (loadImageFailed)="loadImageFailed()"
                ></image-cropper>
            </div>
        </custom-scroll>
    </ng-container>
</gsp-popup>
